import { createEntityAdapter } from '@reduxjs/toolkit';

const creativesAdapter = createEntityAdapter();

export default creativesAdapter;
